module.exports = __webpack_public_path__ + "static/media/starfish.335f9e2f.svg";